import { FlexBox, Spinner } from '@dixa/lib-shared-habla';

export const LoadingItem = () => (
  <FlexBox justifyContent="center" padding="200">
    <Spinner size={16} />
  </FlexBox>
);
